// 所有主题共用同一版本号和 API 版本号，避免逐主题重复声明
// （重构前 11 个主题每个都重复 '1.9.7' 和 '8'，对外部访问路径和值完全无影响）
const ALL_THEMES = ['rrty-theme', '88zb-theme', 'kqzb-theme', 'bszb-theme', 'kqzbcc-theme', 'wqzb-theme', 'fszb-theme', 'fqzb-theme', 'lmzb-theme', 'okzb-theme', 'vnzb-theme']
const buildUniformMap = (value) => ALL_THEMES.reduce((acc, key) => (acc[key] = value, acc), {})

const themeDetail = {
  themeTitle: {
    'rrty-theme': '人人体育-欧洲杯直播_世界杯直播_五大联赛直播_NBA直播_电竞直播,足球篮球全量数据',
    '88zb-theme': '看球直播-欧洲杯直播_世界杯直播_五大联赛直播_NBA直播_电竞直播,足球篮球全量数据',
    'kqzb-theme': '看球直播-欧洲杯直播_世界杯直播_五大联赛直播_NBA直播_电竞直播,足球篮球全量数据',
    'bszb-theme': '比赛直播-欧洲杯直播_世界杯直播_五大联赛直播_NBA直播_电竞直播,足球篮球全量数据',
    'kqzbcc-theme': '看球直播-欧洲杯直播_世界杯直播_五大联赛直播_NBA直播_电竞直播,足球篮球全量数据',
    'wqzb-theme': '玩球直播-欧洲杯直播_世界杯直播_五大联赛直播_NBA直播_电竞直播,足球篮球全量数据',
    'fszb-theme': '飞速直播-欧洲杯直播_世界杯直播_五大联赛直播_NBA直播_电竞直播,足球篮球全量数据',
    'fqzb-theme': '飞球直播-欧洲杯直播_世界杯直播_五大联赛直播_NBA直播_电竞直播,足球篮球全量数据',
    'lmzb-theme': '零秒直播-欧洲杯直播_世界杯直播_五大联赛直播_NBA直播_电竞直播,足球篮球全量数据',
    'okzb-theme': 'OK直播-欧洲杯直播_世界杯直播_五大联赛直播_NBA直播_电竞直播,足球篮球全量数据',
    'vnzb-theme': 'VN Live-欧洲杯直播_世界杯直播_五大联赛直播_NBA直播_电竞直播,足球篮球全量数据',
  },
  themekeywords: {
    'rrty-theme': '人人体育,欧洲杯直播,世界杯直播,五大联赛直播,NBA直播,电竞直播',
    '88zb-theme': '看球直播,欧洲杯直播,世界杯直播,五大联赛直播,NBA直播,电竞直播',
    'kqzb-theme': '看球直播,欧洲杯直播,世界杯直播,五大联赛直播,NBA直播,电竞直播',
    'bszb-theme': '比赛直播,欧洲杯直播,世界杯直播,五大联赛直播,NBA直播,电竞直播',
    'kqzbcc-theme': '看球直播,欧洲杯直播,世界杯直播,五大联赛直播,NBA直播,电竞直播',
    'wqzb-theme': '玩球直播,欧洲杯直播,世界杯直播,五大联赛直播,NBA直播,电竞直播',
    'fszb-theme': '飞速直播,欧洲杯直播,世界杯直播,五大联赛直播,NBA直播,电竞直播',
    'fqzb-theme': '飞球直播,欧洲杯直播,世界杯直播,五大联赛直播,NBA直播,电竞直播',
    'lmzb-theme': '零秒直播,欧洲杯直播,世界杯直播,五大联赛直播,NBA直播,电竞直播',
    'okzb-theme': 'OK直播,欧洲杯直播,世界杯直播,五大联赛直播,NBA直播,电竞直播',
    'vnzb-theme': '人人体育,欧洲杯直播,世界杯直播,五大联赛直播,NBA直播,电竞直播',
  },
  themeDescription: {
    'rrty-theme': '人人体育为用户免费提供世界杯高清直播★欧洲杯高清直播★NBA高清直播★足球赛事直播★篮球赛事直播★电竞赛事直播★CBA直播★欧冠英超意甲西甲德甲直播等,国内外体育赛事直播,另有全网最快最全足球篮球电竞全量数据资料库有料推荐等赛事相关服务。',
    '88zb-theme': '看球直播为用户免费提供世界杯高清直播★欧洲杯高清直播★NBA高清直播★足球赛事直播★篮球赛事直播★电竞赛事直播★CBA直播★欧冠英超意甲西甲德甲直播等,国内外体育赛事直播,另有全网最快最全足球篮球电竞全量数据资料库有料推荐等赛事相关服务。',
    'kqzb-theme': '看球直播为用户免费提供世界杯高清直播★欧洲杯高清直播★NBA高清直播★足球赛事直播★篮球赛事直播★电竞赛事直播★CBA直播★欧冠英超意甲西甲德甲直播等,国内外体育赛事直播,另有全网最快最全足球篮球电竞全量数据资料库有料推荐等赛事相关服务。',
    'bszb-theme': '比赛直播为用户免费提供世界杯高清直播★欧洲杯高清直播★NBA高清直播★足球赛事直播★篮球赛事直播★电竞赛事直播★CBA直播★欧冠英超意甲西甲德甲直播等,国内外体育赛事直播,另有全网最快最全足球篮球电竞全量数据资料库有料推荐等赛事相关服务。',
    'kqzbcc-theme': '看球直播为用户免费提供世界杯高清直播★欧洲杯高清直播★NBA高清直播★足球赛事直播★篮球赛事直播★电竞赛事直播★CBA直播★欧冠英超意甲西甲德甲直播等,国内外体育赛事直播,另有全网最快最全足球篮球电竞全量数据资料库有料推荐等赛事相关服务。',
    'wqzb-theme': '玩球直播为用户免费提供世界杯高清直播★欧洲杯高清直播★NBA高清直播★足球赛事直播★篮球赛事直播★电竞赛事直播★CBA直播★欧冠英超意甲西甲德甲直播等,国内外体育赛事直播,另有全网最快最全足球篮球电竞全量数据资料库有料推荐等赛事相关服务。',
    'fszb-theme': '飞速直播为用户免费提供世界杯高清直播★欧洲杯高清直播★NBA高清直播★足球赛事直播★篮球赛事直播★电竞赛事直播★CBA直播★欧冠英超意甲西甲德甲直播等,国内外体育赛事直播,另有全网最快最全足球篮球电竞全量数据资料库有料推荐等赛事相关服务。',
    'fqzb-theme': '飞球直播为用户免费提供世界杯高清直播★欧洲杯高清直播★NBA高清直播★足球赛事直播★篮球赛事直播★电竞赛事直播★CBA直播★欧冠英超意甲西甲德甲直播等,国内外体育赛事直播,另有全网最快最全足球篮球电竞全量数据资料库有料推荐等赛事相关服务。',
    'lmzb-theme': '零秒直播为用户免费提供世界杯高清直播★欧洲杯高清直播★NBA高清直播★足球赛事直播★篮球赛事直播★电竞赛事直播★CBA直播★欧冠英超意甲西甲德甲直播等,国内外体育赛事直播,另有全网最快最全足球篮球电竞全量数据资料库有料推荐等赛事相关服务。',
    'okzb-theme': 'OK直播为用户免费提供世界杯高清直播★欧洲杯高清直播★NBA高清直播★足球赛事直播★篮球赛事直播★电竞赛事直播★CBA直播★欧冠英超意甲西甲德甲直播等,国内外体育赛事直播,另有全网最快最全足球篮球电竞全量数据资料库有料推荐等赛事相关服务。',
    'vnzb-theme': '人人体育为用户免费提供世界杯高清直播★欧洲杯高清直播★NBA高清直播★足球赛事直播★篮球赛事直播★电竞赛事直播★CBA直播★欧冠英超意甲西甲德甲直播等,国内外体育赛事直播,另有全网最快最全足球篮球电竞全量数据资料库有料推荐等赛事相关服务。',
  },
  themeName: {
    'rrty-theme': '人人体育',
    '88zb-theme': '看球直播',
    'kqzb-theme': '看球直播',
    'bszb-theme': '比赛直播',
    'kqzbcc-theme': '看球直播',
    'wqzb-theme': '玩球直播',
    'fszb-theme': '飞速直播',
    'fqzb-theme': '飞球直播',
    'lmzb-theme': '零秒直播',
    'okzb-theme': 'OK直播',
    'vnzb-theme': '人人体育',
  },
  themeEnName: {
    'rrty-theme': 'rrty',
    '88zb-theme': '88zb',
    'kqzb-theme': 'kqzb',
    'bszb-theme': 'bszb',
    'kqzbcc-theme': 'kqzbcc',
    'wqzb-theme': 'wqzb',
    'fszb-theme': 'fszb',
    'fqzb-theme': 'fqzb',
    'lmzb-theme': 'lmzb',
    'okzb-theme': 'okzb',
    'vnzb-theme': 'vnzb',
  },
  themeWz: {
    'rrty-theme': 'rrty.tv',
    '88zb-theme': 'kanqiu.com',
    'kqzb-theme': 'kqzb.com',
    'bszb-theme': 'bszb.com',
    'kqzbcc-theme': 'kq.cc',
    'wqzb-theme': 'wqzb.com',
    'fszb-theme': 'fszb.com',
    'fqzb-theme': 'fqzb.com',
    'lmzb-theme': 'lmzb.com',
    'okzb-theme': 'okzb.com',
    'vnzb-theme': 'vnzb.tv',
  },
  themeBbh: buildUniformMap('1.9.7'),
  themeApiVersion: buildUniformMap('8'),
  codenum: {
    'rrty-theme': 'https://s9.cnzz.com/z_stat.php?id=1279342653&web_id=1279342653',
    '88zb-theme': 'https://s4.cnzz.com/z_stat.php?id=1279782119&web_id=1279782119',
    'kqzb-theme': 'https://s9.cnzz.com/z_stat.php?id=1281186514&web_id=1281186514',
    'bszb-theme': 'https://v1.cnzz.com/z_stat.php?id=1281186522&web_id=1281186522',
    'kqzbcc-theme': 'https://s9.cnzz.com/z_stat.php?id=1281188705&web_id=1281188705',
    'wqzb-theme': 'https://s9.cnzz.com/z_stat.php?id=1281293568&web_id=1281293568',
    'fszb-theme': 'https://s9.cnzz.com/z.js?id=1281294330',
    'fqzb-theme': 'https://s4.cnzz.com/z.js?id=1281431233&async=1',
    'lmzb-theme': 'https://v1.cnzz.com/z.js?id=1281461769',
    'okzb-theme': 'https://v1.cnzz.com/z.js?id=1281462472',
    'vnzb-theme': 'https://s9.cnzz.com/z_stat.php?id=1279342653&web_id=1279342653',
  },
  privateCdn: {
    'rrty-theme': 'https://resource-rr.erhraoe.cn/webImgs/changeSkin/rrty-theme/',
    // '88zb-theme': 'https://resource-kq3.erhraoe.cn/webImgs/changeSkin/kqzb-theme/',
    // 'kqzb-theme': 'https://resource-kq.erhraoe.cn/webImgs/changeSkin/kqzb-theme/',
    // 'bszb-theme': 'https://resource-bs.erhraoe.cn/webImgs/changeSkin/bszb-theme/',
    // 'kqzbcc-theme': 'https://resource-kqcc.erhraoe.cn/webImgs/changeSkin/kqzbcc-theme/',
    // 'wqzb-theme': 'https://resource-wq.erhraoe.cn/webImgs/changeSkin/wqzb-theme/',
    'fszb-theme': 'https://rsfs.fangujn.com/webImgs/changeSkin/fszb-theme/',
    // 'fqzb-theme': 'https://resource-fq.elrepvy.cn/webImgs/changeSkin/fqzb-theme/',
    // 'lmzb-theme': 'https://res-im.ahjahj.cn/webImgs/changeSkin/rrty-theme/',
    'okzb-theme': 'https://oksrc.aidaid.cn/webImgs/changeSkin/okzb-theme/',
    'vnzb-theme': 'https://resource-rr.erhraoe.cn/webImgs/changeSkin/vnzb-theme/',
  },
  publickCdn: {
    'rrty-theme': 'https://kbsource.hg6d13z3cl3pb91d.cc/',
    // '88zb-theme': 'https://resource-kq3.erhraoe.cn/webImgs/changeSkin/kqzb-theme/public/',
    // 'kqzb-theme': 'https://resource-kq.erhraoe.cn/webImgs/changeSkin/public/',
    // 'bszb-theme': 'https://resource-bs.erhraoe.cn/webImgs/changeSkin/public/',
    // 'kqzbcc-theme': 'https://resource-kqcc.erhraoe.cn/webImgs/changeSkin/public/',
    // 'wqzb-theme': 'https://resource-wq.erhraoe.cn/webImgs/changeSkin/public/',
    'fszb-theme': 'https://kbsource.hg6d13z3cl3pb91d.cc/',
    // 'fqzb-theme': 'https://resource-fq.elrepvy.cn/webImgs/changeSkin/public/',
    // 'lmzb-theme': 'https://res-im.ahjahj.cn/webImgs/changeSkin/public/',
    'okzb-theme': 'https://kbsource.hg6d13z3cl3pb91d.cc/',
    'vnzb-theme': 'https://kbsource.hg6d13z3cl3pb91d.cc/',
  },
  publickCdnjs: {
    'rrty-theme': 'https://kbsource.hg6d13z3cl3pb91d.cc/',
    // '88zb-theme': 'https://resource-rr.erhraoe.cn/web_js/public/',
    // 'kqzb-theme': 'https://resource-rr.erhraoe.cn/web_js/public/',
    // 'bszb-theme': 'https://resource-rr.erhraoe.cn/web_js/public/',
    // 'kqzbcc-theme': 'https://resource-rr.erhraoe.cn/web_js/public/',
    // 'wqzb-theme': 'https://resource-rr.erhraoe.cn/web_js/public/',
    'fszb-theme': 'https://kbsource.hg6d13z3cl3pb91d.cc/',
    // 'fqzb-theme': 'https://resource-rr.erhraoe.cn/web_js/public/',
    // 'lmzb-theme': 'https://res-im.ahjahj.cn/web_js/public/',
    'okzb-theme': 'https://kbsource.hg6d13z3cl3pb91d.cc/',
    'vnzb-theme': 'https://kbsource.hg6d13z3cl3pb91d.cc/',
  }
}
module.exports = themeDetail